import { BrandAndProduct, Entity, formatTicker } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { NonLinearStepper } from '~/components/non-linear-stepper/NonLinearStepper';
import { GeoSourceEvidenceSection } from '~/widgets/company-to-geo-widget/tabs/components/source-evidence-section/GeoSourceEvidenceSection';
import { TopRankIcon } from '~/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';

import * as S from './BrandAndProductDrawerContent.styles';

export interface BrandAndProductDrawerContentProps {
  entity: Entity;
  logoUrl: string;
  productAndBrand: BrandAndProduct;
  title?: string;
}

export const BrandAndProductDrawerContent = ({
  entity,
  logoUrl,
  productAndBrand,
  title,
}: BrandAndProductDrawerContentProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <S.Root>
      <S.SectionRow data-testid="product-stepper-section">
        {title && <S.TitleMedium>{title}</S.TitleMedium>}
        <S.StepperWrapper>
          <NonLinearStepper
            activeIndex={0}
            steps={[
              {
                logoUrl: logoUrl,
                hoverLabel: formatTicker(entity),
                connectorLabel: t('widget:assetOverview.knowledgeGraph.offers'),
                isSimple: false,
                highlightConnector: true,
              },
              {
                imgNode: <S.StyledIcon iconName="Award" size={18} />,
                iconColor: 'var(--kg-brand)',
                hoverLabel: '',
                highlightConnector: true,
              },
            ]}
            iconSize={23}
          />
        </S.StepperWrapper>
        <S.BodySmall>{productAndBrand.relationship.description}</S.BodySmall>
      </S.SectionRow>
      <S.SectionRow>
        <S.TitleBase>
          {t(
            'widget:assetOverview.knowledgeGraph.brandsAndProducts.brandAndProductRank'
          )}
        </S.TitleBase>
        <S.StyledRankWrapper>
          <S.RankContainer>
            <S.RankLabel>
              {t(
                'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.current'
              )}
            </S.RankLabel>
            <S.RankFlexRow>
              <TopRankIcon rank={productAndBrand.relationship.rank} />
            </S.RankFlexRow>
          </S.RankContainer>
        </S.StyledRankWrapper>
      </S.SectionRow>
      <ErrorBoundaryWrapper>
        <GeoSourceEvidenceSection
          evidence={productAndBrand.relationship.evidence ?? []}
          sourceEvidence={productAndBrand.relationship.source_evidence ?? null}
        />
      </ErrorBoundaryWrapper>
    </S.Root>
  );
};
